// extracted by css-extract-rspack-plugin
export default {"cls1":"FreeformQuestion-cls1_y8T","cls2":"FreeformQuestion-cls2_IE8 FreeformQuestion-cls1_y8T"};